module.exports = __webpack_public_path__ + "img/14-1_07.da024fcb.jpg";